module.exports = __webpack_public_path__ + "img/Trillionaire-1.e16c591c.gif";